import { PlusOutlined } from "@ant-design/icons"
import { current, unwrapResult } from "@reduxjs/toolkit"
import { Button, Form, message, notification, Row, Space, Table } from "antd"
import React, {
  ReactElement,
  useEffect,
  useState,
} from "react"
import { useDispatch } from "react-redux"
import styles from "./drinkingWater.module.css"
import moment from "moment"
import { RootDispatch } from "../../app/store"
import { TabBar, TabPane } from "../../compnents/widgets/TabBar"
import { EditableList } from "../../compnents/list/EditableList"
import { DrinkingWaterColumns } from "./columns"
import {
  DateRangeType,
  DateSelect,
  TJFXTime,
} from "../../compnents/form/DateSelect"
import { MainModal } from "./MainModal"
import { getSJWHTokenAsync } from "../dataMaintenance/organization/data"
import axios from "axios"
import { AXIOS_IP_WATER } from "../filingManagement/fileUploadService"
import { DateTimeFormatSimpleOnlyOne } from "../../models/datetime"
export const DrinkingWater = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [isModalVisible, setIsModalVisible] = useState(false)
  
  const [pageLoading, setPageLoading] = useState(false)

  const [isCreate, setIsCreate] = useState(false)

  const [token, setToken] = useState('')

  const [currentId, setCurrentId] = useState<any>()

  const [form] = Form.useForm()

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [params, setParams] = useState<any>({
    pageSize: 10,
    pageNo: 1,
    searchTimeList: [
      moment().startOf('month').format(DateTimeFormatSimpleOnlyOne), 
      moment().endOf('month').format(DateTimeFormatSimpleOnlyOne)
    ],
  })

  const getData = () => {
    setPageLoading(true)
    dispatch(getSJWHTokenAsync())
      .then(unwrapResult)
      .then((token: any) => {
        setToken(token)
        axios({
          url: `${AXIOS_IP_WATER}/drinkingWater/list`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": token,
          },
          withCredentials: false,
          method: "POST",
          data: { ...params },
        }).then((res) => {
          setPage({
            ...page,
            items: res.data.data?.list,
            total: res.data.data?.total,
          })
          setPageLoading(false)
        })
      }).finally(() => setPageLoading(false))
  }

  useEffect(() => {
    getData()
  }, [params])

  return (
    <>
      <TabBar style={{ margin: "10px 20px", position: "relative" }}>
        <TabPane key="0" tab="饮用水管理">
          <Button
            style={{ position: "absolute", right: 20, top: 3 }}
            type="primary"
            onClick={() => {
              if(page.items?.length > 0) {
                setCurrentId(page.items[0]?.id)
                setIsCreate(true)
                setIsModalVisible(true)
              } else {
                setCurrentId('')
                setIsModalVisible(true)
              }
            }}
          >
            申报
          </Button>
          <div className={styles.content}>
            <Form
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              form={form}
              onFinish={(values) => {
                if (!values?.searchTimeListHead && values?._dateRange == 6) {
                  return
                }
                setParams({
                  ...params,
                  ...values,
                  searchTimeList: values?.searchTimeListHead ? 
                    [
                      moment(values?.searchTimeListHead).format(DateTimeFormatSimpleOnlyOne), 
                      moment(values?.searchTimeListTail).format(DateTimeFormatSimpleOnlyOne)
                    ]
                    : params.searchTimeList,
                  searchTimeListHead: undefined,
                  searchTimeListTail: undefined,
                  pageNo: 1,
                })
              }}
            >
              <Row
                style={{ marginBottom: 10, width: "100%" }}
                align="middle"
                justify="space-between"
              >
                <Space>
                  <DateSelect
                    allowClear={false}
                    style={{ width: "10rem" }}
                    labelPrefix="申报时间-"
                    namePrefix="searchTimeList"
                    options={TJFXTime}
                    placeholder="申报时间"
                    initialValue={DateRangeType.ThisMonth}
                    onChange={() => form.submit()}
                  />
                  <Button loading={pageLoading} type="primary" onClick={() => form.submit()}>
                    查询
                  </Button>
                </Space>
              </Row>
            </Form>
            <EditableList
              className={styles.statement}
              loading={pageLoading}
              rowKey={(t: any) => t.id}
              onChangePage={(current, pageSize) => {
                setParams({
                  ...params,
                  pageNo: current,
                  pageSize,
                })
              }}
              page={{
                items: page.items,
                current: params.pageNo || 1,
                size: params.pageSize || 10,
                total: page.total,
              }}
              columns={DrinkingWaterColumns((id) => {
                setCurrentId(id)
                setIsCreate(false)
                setIsModalVisible(true)
              }, params.pageSize * (params.pageNo - 1))}
            />
          </div>
        </TabPane>
      </TabBar>

      <MainModal 
        visible={isModalVisible}
        token={token}
        isCreate={isCreate}
        againId={currentId}
        onOk={() => {
          setIsModalVisible(false)
          getData()
        }}
        onCancel={() => setIsModalVisible(false)}
      />
    </>
  )
}
